<template>
  <div class="page-main home-main">
    <div class="container">
      <XiaoMiSG />
      <!-- <Shouji />
      <JiaDian />
      <ShiPing /> -->
    </div>
  </div>
</template>

<script>
import XiaoMiSG from "@/components/PageMain/XiaoMiSG";
import Shouji from "@/components/PageMain/Shouji";
import JiaDian from "@/components/PageMain/JiaDian";
import ShiPing from "@/components/PageMain/ShiPing";


export default {
  name: "PageMain",
  components: {
    XiaoMiSG,
    Shouji,
    JiaDian,
    ShiPing,
  },
};
</script>

<style>
.home-main {
  padding-top: 4px;
  padding-bottom: 12px;
}
.page-main {
  background: #f5f5f5;
}
.container {
  width: 1226px;
  margin-right: auto;
  margin-left: auto;
}
</style>